if (!customElements.get('card-gallery')) {
  customElements.define(
    'card-gallery',
    class CardGallery extends HTMLElement {
      constructor() {
        super();

        /** @type {HTMLElement | null} */
        this.gallery = this.querySelector('[data-gallery]');

        /** @type {HTMLElement | null} */
        this.pagination = this.querySelector('[data-gallery-pagination]');

        /** @type {import('swiper').Swiper | null} */
        this.instance = null;

        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
      }

      connectedCallback() {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.init();

              observer.unobserve(this);
            }
          });
        });

        observer.observe(this);
      }

      disconnectedCallback() {
        this.removeEventListener('mouseenter', this.handleMouseEnter);
        this.removeEventListener('mouseleave', this.handleMouseLeave);

        if (this.instance) {
          this.instance.destroy();
          this.instance = null;
        }
      }

      init() {
        const swiper = window.swiper.Swiper;

        if (this.gallery && this.pagination) {
          this.instance = new swiper(this.gallery, {
            modules: [window.swiper.Pagination, window.swiper.EffectFade],

            slidesPerView: 1,
            spaceBetween: 4,
            loop: true,
            speed: 250,
            effect: 'fade',
            fadeEffect: {
              crossFade: true,
            },
            longSwipes: false,
            pagination: {
              enabled: true,
              el: this.pagination,
            },
          });

          this.addEventListener('mouseenter', this.handleMouseEnter);
          this.addEventListener('mouseleave', this.handleMouseLeave);
        }
      }

      handleMouseEnter() {
        if (this.instance && window.innerWidth > 1024) {
          this.instance.slideToLoop(1, 250);
        }
      }

      handleMouseLeave() {
        if (this.instance && window.innerWidth > 1024) {
          this.instance.slideToLoop(0, 250);
        }
      }
    },
  );
}
